import React from 'react';
import { Headline, Text } from '@oneaudi/unified-web-alpha-components';
import { SectionWrapper, SmallSectionWrapper, Title, TitleSmall } from '../DitigalLeads.styles';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
}

const GroupInputs: React.FC<FormSectionProps> = ({ title, children }) => {
  const isLegacy = process.env.IS_LEGACY;
  return (
    <SectionWrapper>
      {isLegacy ? (
        <Title>{title}</Title>
      ) : (
        <Headline
          variant={{ type: 'headline', order: '4', weight: 'normal' }}
          tag="h2"
          margin={['0', '0', '24px', '0']}
        >
          {title}
        </Headline>
      )}
      {children}
    </SectionWrapper>
  );
};

export const SmallGroupInputs: React.FC<FormSectionProps> = ({ title, children }) => {
  const isLegacy = process.env.IS_LEGACY;
  return (
    <SmallSectionWrapper>
      {isLegacy ? (
        <TitleSmall>{title}</TitleSmall>
      ) : (
        <Text margin={['0', '0', '24px', '0']}>{title}</Text>
      )}
      {children}
    </SmallSectionWrapper>
  );
};

export default GroupInputs;
